/* eslint-disable react-native/no-inline-styles */
/**
 * @author TankNee 2020-08-12
 */
import React from "react";
import FAIcon from "react-native-vector-icons/FontAwesome5";
import Constants from "../../config/Constants";
import * as Helper from "../../utils/Helper";
import { Image, View } from "react-native";
import Sentence from "./Sentence";
import Video from "react-native-video";

class ContentFieldRender extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            paused: true,
            audioPath: "",
        };
    }
    render() {
        const { richArticleChildren } = this.props;
        // Constants
        return (
            <View
                style={{
                    display: "flex",
                    flexDirection: "column",
                    flexWrap: "wrap",
                    backgroundColor: "rgb(240,240,240)",
                    borderRadius: 8,
                    padding: 10,
                }}>
                <Video
                    audioOnly={true}
                    paused={this.state.paused}
                    source={{ uri: Helper.convertToAbsoluteUrl(this.state.audioPath) }} // Can be a URL or a local file.
                    ref={self => {
                        this.player = self;
                    }} // Store reference
                    onEnd={() => {
                        this.setState({ paused: true }, () => {
                            this.player.seek(0);
                        });
                    }}
                    style={{ width: 1, height: 1 }}
                />
                {richArticleChildren &&
                    richArticleChildren.map((child, index) => {
                        let content = null;
                        let { fieldPayload } = child;
                        fieldPayload = JSON.parse(child.fieldPayload);
                        switch (child.type) {
                            case Constants.FIELD_TYPE.CHARSFIELD:
                                content = (
                                    <View>
                                        {fieldPayload.sentences &&
                                            fieldPayload.sentences.map((sentence, sentenceIndex) => {
                                                return (
                                                    <Sentence
                                                        key={sentenceIndex}
                                                        pinyinVisible={false}
                                                        style={{
                                                            borderRadius: 4,
                                                            flexWrap: "wrap",
                                                        }}
                                                        data={sentence}
                                                    />
                                                );
                                            })}
                                    </View>
                                );
                                break;
                            case Constants.FIELD_TYPE.IMAGEFIELD:
                                content = <Image source={{ uri: Helper.convertToAbsoluteUrl(fieldPayload.imagePath) }} resizeMode={"stretch"} style={{ width: 100, height: 100 }} />;
                                break;
                            case Constants.FIELD_TYPE.AUDIOFIELD:
                                content = (
                                    <View style={{ alignItems: "center", justifyContent: "center" }}>
                                        <FAIcon
                                            style={{ marginHorizontal: 5 }}
                                            color={"#EEBE68"}
                                            name={"play"}
                                            size={30}
                                            onPress={() => {
                                                this._handlePlayAudio(fieldPayload.audioPath);
                                            }}
                                        />
                                    </View>
                                );
                                break;
                            default:
                                break;
                        }
                        return (
                            <View key={index} style={{ marginVertical: 5 }}>
                                {content}
                            </View>
                        );
                    })}
            </View>
        );
    }

    _handlePlayAudio = audioPath => {
        if (this.player) {
            this.setState({ audioPath: audioPath }, () => {
                this.setState({ paused: false });
            });
        }
    };

    _handleStopAudio = () => {
        this.setState({ paused: true }, () => {
            this.player.seek(0);
        });
    };
}
export default ContentFieldRender;
